import * as React from "react";
import { Scrollbars } from "react-custom-scrollbars";
import clsx from "clsx";
import { CustomScrollbars } from "../../Scrollbar";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setScrollPosition } from "../../../store/uiDataSlice";
import { NewMenu } from "./newMenu/NewMenu";
import { consoleMenuCategories, homeMenuCategories } from "./newMenu/menuConfig";
import { selectContext } from "../../../store/contextSlice";
import { selectOrgs } from "../../../store/userDataSlice";
import { GoToConsoleSection } from "./newMenu/GoToConsoleSection";

export const MenuLeft: React.FC = () => {
  const dispatch = useAppDispatch();
  const scrollTop = useAppSelector((state) => state.uiData.scrollTop);
  const dashboard = useAppSelector((state) => state.uiData.dashboard);
  const context = useAppSelector(selectContext);
  const orgs = useAppSelector(selectOrgs);

  const scrollbarRef = React.useRef<Scrollbars>(null);

  React.useEffect(() => {
    scrollbarRef.current?.scrollTop(scrollTop);
  }, []);

  // In home dashboard, show console categories if user has org selected
  const showConsoleInHome = dashboard === "home" && !!context.org;
  // Show "Go to Console" section if in home, no org selected, but has orgs available
  const showGoToConsole = dashboard === "home" && !context.org && orgs.length > 0;

  return (
    <div className={clsx("sidebar-container")} style={{ minHeight: "100%" }}>
      <CustomScrollbars
        autoHide
        ref={scrollbarRef}
        className="sidebar-scrollbar"
        onUpdate={(values) => dispatch(setScrollPosition(values.scrollTop))}
        thumbStyle={{ width: "auto" }}
      >
        <div className="sidebar">
          <div className="sidebar-console">
            {showGoToConsole && <GoToConsoleSection />}
            {dashboard === "home" && !showConsoleInHome && <NewMenu menuCategories={homeMenuCategories} />}
            {(dashboard === "console" || showConsoleInHome) && (
              <NewMenu menuCategories={consoleMenuCategories} showFavorites={showConsoleInHome} />
            )}
          </div>
        </div>
      </CustomScrollbars>
    </div>
  );
};
